import { Text } from "@chakra-ui/react";
import * as React from "react";
import {
  ActivityFragment,
  CampaignSummaryFragment,
  UserMinimalFragment,
} from "../../../graphql/generated/definitions";
import useTranslations from "../../../hooks/useTranslations";
import UserAvatar from "../../utils/avatars/UserAvatar";
import Link from "../../utils/Link";
import Activity from "../ActivityPlate";

type UserDocumentAddedActivity = ActivityFragment & {
  recipient: CampaignSummaryFragment;
  trackable: UserMinimalFragment;
};

export function isUserDocumentAddedActivity(
  q: ActivityFragment
): q is UserDocumentAddedActivity {
  return q.key === "user.document_added";
}

interface UserDocumentAddedActivityProps {
  activity: UserDocumentAddedActivity;
}

export const UserDocumentAddedActivity: React.FC<UserDocumentAddedActivityProps> =
  ({ activity }) => {
    const t = useTranslations();

    return (
      <Activity
        activity={activity}
        id="userDocumentAddedActivity"
        visual={
          <UserAvatar
            src={activity.trackable.avatar}
            alt={`${activity.trackable.name} avatar`}
            size={10}
          />
        }
      >
        <Text fontSize="sm">
          {t("activity.labels.userDocumentAdded", {
            user: (
              <Link to={`/users/${activity.trackable.slug}`}>
                {activity.trackable.name}
              </Link>
            ),
          })}
        </Text>
      </Activity>
    );
  };
